export const locale = {
  GLOBAL: {
    Title: "短信乐园",
    PostalCode: "邮政编码",
    postalCodes: "邮政编码",
    selectedPostalCodes: "已选邮政编码",
    MciNumberCount: "伊朗移动（MCI）号码数量",
    MtuNumberCount: "伊朗移动（MTN/Irancell）号码数量",
    TotalCount: "总数",
    Coefficient: "系数",
    Back: "返回",
  },
  ERRORS: {
    PhoneIsNotValid: "输入的手机号码格式不正确：示例 09101234567",
    InvalidNumber: "输入的数量不正确",
    NoSelectedLineNumber: "请选择发送线路。",
    EmptyText: "请输入短信内容。",
    UnknownError: "未知错误",
    TryAgain: "请稍后重试。",
    NoAccountCharge: "余额不足",
    NoAccess: "您没有权限。",
    PleasebyeAPlane: "请先购买一个套餐。",
    PleaseChargeYourAccount: "请为您的账户充值。",
    AccessDenied: "访问被拒绝。",
    AccessDeniedDescription: "如需更多信息，请联系客服",
    Error: "错误",
    InvalidText: "短信内容无效",
    InvalidTextContainsLink: "只有服务线路可以发送包含链接的内容。",
  },
  INFOS: {
    SuccessSentSms: "短信发送成功",
    SmsRequestInQueue: "您的短信将在管理员审核后发送",
    SendData: "发送信息",
    CheckData: "请阅读并确认以下信息。",
  },
  TOBE: {
    to: "至 ",
    from: "从 ",
  },
  FORMS: {
    DestinationPhone: "接收手机号",
    TestDestinationPhone: "测试手机号",
    SourceNumber: "发送号码",
    Text: "短信内容",
    CharCount: "字符数",
    FarsiCharCount: "波斯文字符数",
    EnglishCharCount: "英文字符数",
    Send: "发送",
    SendTime: "发送时间",
    SendTest: "发送测试",
    SendToTestNumber: "发送到测试号码",
    SmsCount: "短信条数",
    SmsLang: "短信语言",
    Add: "添加",
    FromFile: "从文件添加",
    TestNumber: "测试号码",
    Test: "测试",
    ServiceRelated: "服务类",
    Price: "价格",
    NumbersCount: "号码数量",
    NumbersCountToSend: "将要发送短信的号码数量",
    Search: "搜索",
    Title: "标题",
    RequestTime: "请求时间",
    RequestInformation: "请求信息",
    CreateNewPhoneBook: "新建电话簿",
  },
  BUTTONS: {
    OK: "确定",
    AccountCharge: "账户充值",
    Reports: "报告",
    RemoveAll: "全部删除",
    BuyAPlane: "购买套餐",
    Accept: "确认",
    Reject: "拒绝",
    Yes: "是",
    No: "否",
    Create: "创建",
    New: "新建",
    Save: "保存",
    Delete: "删除",
    More: "更多",
    TryAgain: "重试",
    Close: "关闭",
    RollBack: {
      back: "返回上一个用户",
      goToMainUser: "返回主用户",
      CurrentUser: "当前用户",
    },
  },
  DIALOGS: {
    Waiting: "请稍候",
    RejectItQuestion: "是否拒绝？",
    AcceptItQuestion: "是否确认？",
    Rejected: "已拒绝",
    Accepted: "已确认",
    Error: "错误",
  },
  CONFIRM: {
    Delete: "您确定要删除吗？",
    DeleteA: "您确定要删除 {a} 吗？",
    DeleteALL: "您确定要全部删除吗？",
  },
  LANGUAGE: {
    English: "英语",
    Persian: "波斯语",
  },
  language: {
    selectAll: "全选",
    lang: {
      fa: "波斯语",
      ar: "阿拉伯语",
      ar_ae: "阿拉伯语 (阿联酋)",
      ar_iq: "阿拉伯语 (伊拉克)",
      en_US: "英语 (美国)",
      en_GB: "英语 (英国)",
      de: "德语",
      fr: "法语",
      zh_CN: "简体中文",
      zh_TW: "繁体中文",
      tr: "土耳其语",
      ru: "俄语",
      hy: "亚美尼亚语",
    },
    only_manual_now: "目前仅支持手动翻译",
    ai_coming_soon: "AI 翻译即将上线",
    got_it: "知道了",
    origin_language: "源语言",
    target_languages: "目标语言",
    remove_all: "移除所有语言",
    translation_method: "选择翻译方式",
    manual_translation: "手动翻译",
    ai_translation: "AI 翻译",
    coming_soon: "即将推出",
    source_language_updated: "源语言已更新",
    error_changing_source_language: "更改源语言时出错",
    source_language_created: "已创建新源语言",
    languages_saved: "新语言已保存",
    error_saving_languages: "保存语言时出错",
    error_loading_language: "加载语言时出错",
    languages_removed: "已移除的语言",
    new_languages_to_save: "待保存的新语言",
    saved: "已保存",
    management_langs: "语言管理",
    add_langs: "添加语言",
    change_language: "更改语言",
    visit_card: "名片",
    translate_to: "翻译为",
    main_language: "主语言",
    no_languages_available: "无可用语言",
    return_to_default: "返回默认语言",
    translate: "翻译",
    changes_pending: "等待应用更改",
    apply_changes: "应用更改",
    cancel_changes: "取消",
  },
  LISTS: {
    NoData: "暂无数据",
    NoDataFound: "未找到数据",
    NoDataFoundFor: "未找到关于 {a} 的数据",
    NoPhoneNumber: "未找到手机号码",
    NoPostalCode: "未找到邮政编码",
    AddANumber: "请添加一个号码",
    City: "城市",
    AddedBefore: "已添加过",
  },
  PAGES: {
    SendSms: "发送短信",
    MapSms: "地图发送",
    PhoneBook: "电话簿",
  },
  MONETARY: {
    Rial: "里亚尔",
  },
  HINTS: {
    SendMessageTitle:
      "标题是您自定义的名称，可使用之前发送过的短信标题，这样内容会自动填入“短信内容”框。标题不会发送给用户，仅用于报表和短信建议功能。",
    SendMessageTime:
      "发送时间是指您的短信进入发送队列的时间。请注意：若管理员未通过审核，短信将不会发送。",
    CreatePhoneBook: "发送短信时，可通过此名称快速选择已保存的电话簿。",
  },
  TOASTS: {
    SuccessCreate: "创建成功",
    FailedCreated: "创建失败",
    SuccessDelete: "删除成功",
    FailedDelete: "删除失败",
    SuccessEdit: "编辑成功",
    FailedEdit: "编辑失败",
    AddedSuccess: "添加成功",
    AddedFailed: "添加失败",
  },
  WALLET: {
    CustomCharge: "自定义金额",
    GateWay: "支付网关",
    Price: "金额",
    Details: [
      "将额外收取9%的税费。",
      "请仔细填写充值金额，充值成功后金额不可退还。",
    ],
    noGateWay: "您尚未配置支付网关。",
    PriceNotInRange: "输入金额必须在 {min} 里亚尔至 {max} 里亚尔之间。",
    Pay: "支付",
    ErrorOnRedirectToGateWay: "跳转到支付网关时出错",
    ChargeWalletButtonDescription: "点击 + 按钮为您的账户充值",
  },
  login: {
    phoneField: {
      placeholderIran: "以9开头（例如：+98 912 345 6789）",
      placeholderDefault: "请输入您的手机号",
      maxDigitsError: "最多允许 {count} 位数字！",
      iranMustStartWith9: "伊朗手机号必须以9开头（如912…）",
    },
    signup_button: "我要注册！",
    forget_password_title: "忘记密码",
    register_title: "免费注册",
    login_title: "登录",
    back: "返回",
    username_label: "手机号/用户名",
    otp_resend_button: "重新发送验证码",
    password_label: "密码",
    password_hint: "至少8个字符",
    name_label: "姓名",
    name_rule: "至少3个字符",
    lastname_label: "姓氏",
    phone_label: "手机号",
    nid_label: "身份证号（国家代码）",
    parent_phone_label: "推荐人手机号（可选）",
    terms_and_conditions_message: "注册即表示您同意广告终端的所有规则和条款。",
    terms_and_conditions_link: "规则与条款",
    close: "关闭",
    forgot_password_link: "忘记密码？",
    change_password: "修改密码",
    register_button: "注册",
    login_button: "登录",
    login_with_google: "使用Google登录",
    login_with_sms: "短信验证码登录",
    login_with_password: "密码登录",
    already_registered: "已有账号？",
    login_here: "立即登录",
    no_account: "还没有账号？",
    signup_now: "立即注册！",
    more_info: "更多信息",
    text_login: "登录",
    text_register: "注册",
    required_field: "此为必填项。",
    min_8_char: "内容少于8个字符",
    required: "此项必填",
    min_3_char: "至少3个字符",
    max_50_char: "最多50个字符",
    no_internet: "您未连接到网络",
    no_phone_entered: "您尚未输入手机号",
    otp_sent_successfully: "验证码已成功发送。",
    please_register_first: "请先注册！",
    wait_3_min: "请等待3分钟后再次请求。",
    login_successful: "登录成功",
    internet_connection_error: "网络连接异常！",
    agree_to_terms_error: "您尚未同意服务条款！",
    otp_sent_successfully_register: "验证码发送成功。",
    error: "错误",
    registration_nid_required_notice:
      "为了提供高安全性服务并防止钓鱼欺诈和系统滥用，在广告终端注册时必须填写身份证号（国家代码）。",
  },
  home: {
    title: "首页",
    selectSystem: "选择系统",
    yourPoints: "您的积分",
    discountCodes: "优惠码",
    all: "全部",
    discounts: "优惠",
    systemGuide: "系统指南",
    yourPointsDynamic: "您的积分：{points}",
    confirm: "确认",
    copy: "复制",
  },
  badges: {
    free: "免费",
    preRegister: "预注册",
    comingSoon: "即将推出",
    testVersion: "测试版",
  },
  services: {
    qrLand: {
      title: "QR乐园系统",
      description: "创建动态二维码",
      property: {
        0: "审查并选择广告类型和位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    payamak: {
      title: "短信乐园系统",
      description: "批量发送广告短信",
      property: {
        0: "批量发送短信",
        1: "拥有最新号码库",
        2: "向客户俱乐部发送短信",
        3: "可连接所有网站和软件",
      },
    },
    robot: {
      title: "机器人乐园系统",
      description: "同时管理所有号码、广告和面板",
      property: {
        0: "批量发布广告",
        1: "定时、渐进、智能管理广告",
        2: "无限租赁和添加发布广告的号码",
        3: "同时注册和管理所有广告",
      },
    },
    infoLand: {
      title: "信息乐园",
      description: "超过2500个最新行业信息数据库",
      property: {
        0: "包含所有行业信息",
        1: "按城市和省份分类",
        2: "全国所有行业信息库",
        3: "可查看所有数据库样本",
      },
    },
    graphic: {
      title: "图形乐园系统",
      description: "从0到100的平面设计与视频制作",
      property: {
        0: "设计LOGO和企业VI",
        1: "所有印刷与包装服务",
        2: "设计目录、手册、包装盒",
        3: "设计并印刷各种尺寸横幅",
      },
    },
    bestWebLand: {
      title: "最佳网站乐园系统",
      description: "网站设计、维护与SEO优化",
      property: {
        0: "内容SEO",
        1: "站外SEO（Off-page）",
        2: "技术SEO（Technical）",
        3: "站内SEO（On-page）",
      },
    },
    onlineShop: {
      title: "在线建站系统",
      description: "只需几点击可进入数字世界",
      badge: "分销合作",
      property: {
        0: "内容SEO",
        1: "站外SEO（Off-page）",
        2: "技术SEO（Technical）",
        3: "站内SEO（On-page）",
      },
    },
    social: {
      title: "社交媒体广告",
      description: "选择最佳账号与频道进行广告投放",
      property: {
        0: "审查所有高流量账号",
        1: "统一管理所有广告",
        2: "无需支付额外佣金",
        3: "在线订购喜欢的账号广告",
      },
    },
    billboard: {
      title: "在线租用广告牌",
      description: "无中介，精准选择广告牌位置",
      property: {
        0: "审查广告牌位置与类型",
        1: "管理所有在网广告牌",
        2: "与广告牌拥有者直接联系",
        3: "无需支付佣金和额外费用",
      },
    },
    internationalMedia: {
      title: "国家级媒体广告",
      description: "在电视和广播投放广告",
      property: {
        0: "审查广告发布时间",
        1: "选择电视广告类型",
        2: "选择广播广告类型",
        3: "选择节目内插播广告",
      },
    },
    transport: {
      title: "交通工具广告",
      description: "机场、火车站、公交、地铁广告",
      property: {
        0: "审查广告类型与位置",
        1: "审查地铁广告类型",
        2: "无需支付额外佣金",
        3: "统一管理所有地铁广告",
      },
    },
    cinema: {
      title: "影院及视频平台广告",
      description: "在影...",
      property: {
        0: "审查广告类型与位置",
        1: "审查影院广告类型",
        2: "无需支付额外佣金",
        3: "统一管理所有影院广告",
      },
    },
    estate: {
      title: "在线房产系统",
      description: "管理房源、顾问与客户",
      property: {
        0: "审查并选择广告类型与位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    AIGeneration: {
      title: "人工智能系统",
      description: "生成图片、智能聊天机器人",
    },
    ShortLink: {
      title: "短链接系统",
      description: "创建短链接",
    },
    customer: {
      title: "在线客户管理系统",
      description: "管理、支持并培养忠诚客户",
      property: {
        0: "审查并选择广告类型与位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    internetBroadcasting: {
      title: "互联网广告投放与管理",
      description: "谷歌广告、点击付费广告、软文推广",
      property: {
        0: "审查并选择广告类型与位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    emailMarketing: {
      title: "邮件营销系统",
      description: "向全国所有行业发送广告邮件",
      property: {
        0: "审查并选择广告类型与位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    adsOnStudium: {
      title: "体育场馆与展会广告",
      description: "让您的品牌出现在最大型活动中心",
      property: {
        0: "审查并选择广告类型与位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    bidOnline: {
      title: "综合在线竞拍系统",
      description: "在线举办拍卖或参与竞拍",
      property: {
        0: "审查并选择广告类型与位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    onlineTools: {
      title: "在线商业工具系统",
      description: "各种类型业务所需的辅助工具",
      property: {
        0: "审查并选择广告类型与位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    onlineLearn: {
      title: "职业在线教育系统",
      description: "精准选择行业培训课程",
      property: {
        0: "审查并选择广告类型与位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    cloud: {
      title: "主机与域名购买",
      description: "购买主机、域名与服务器",
      property: {
        0: "审查并选择广告类型与位置",
        1: "审查并选择影院广告类型",
        2: "无需支付额外佣金和费用",
        3: "统一管理所有影院广告",
      },
    },
    QrlandShop: {
  title: "网店管理",
  description: "一体化管理商品、在线市场和智能定价",
  property: {
    0: "全面监控和管理商品",
    1: "商品规格管理",
    2: "监控和管理在线市场",
    3: "智能定价策略",
  },
},

  },
  "planning.title": "计划安排",
  "tabs.reminder": "提醒事项",
  "tabs.notes": "备忘录",
  "tabs.calendar": "日历",
  "notes.creationDate": "创建日期",
  "common.save": "保存",
  "common.cancel": "取消",
  "actions.quickActions": "快速操作",
  "notes.writeMessage": "写消息",
  "notes.titlePlaceholder": "备忘录标题",
  "notes.addNote": "添加备忘录",
  "notes.updatedSuccess": "备忘录更新成功。",
  "notes.addedSuccess": "备忘录添加成功。",
  "common.deletedSuccess": "删除成功",
  "common.confirmDelete": "您确定要删除吗？",
  "news.title": "网站新闻",
  "news.noNews": "网站暂无新闻。",
  "news.view": "查看",
  "remember.add": "创建提醒",
  "remember.update": "更新提醒",
  "remember.titleLabel": "标题",
  "remember.dateLabel": "提醒日期",
  "remember.confirmDelete": "您确定要删除吗？",
  "remember.deleteSuccess": "提醒删除成功。",
  "remember.createSuccess": "新提醒创建成功。",
  "remember.updateSuccess": "提醒已更新。",
  "points.receivedAwards": "已获得奖励",
  "points.pointsHistory": "积分历史",
  "points.points": "积分",
  "points.discountTitle": "机器人乐园折扣",
  "points.discountText": "每500积分",
  events: {
    title: "事件",
    addEvent: "添加事件",
    calendar: "基础日历",
    close: "关闭",
    save: "保存",
    update: "更新",
    confirmDelete: "您确定要删除吗？",
    successAdd: "添加成功。",
    successDelete: "事件删除成功。",
    successUpdate: "更新成功。",
    titleLabel: "标题",
    descriptionLabel: "描述",
    colorLabel: "颜色",
    removeAfterDrop: "完成后删除",
    createEvent: "创建事件",
  },
  copySuccess: "复制成功。",
  copyTextTitle: "复制",
  copiedTextTitle: "已复制",
  ribbon: {
    new: "新",
  },
  coupons: [
    {
      text: "此优惠券有效期3周",
      title: "独特文案 20%折扣",
    },
    {
      text: "此优惠券有效期2周",
      title: "网站设计 5%折扣",
    },
    {
      text: "此优惠券仅限使用一次",
      title: "页面管理 10%折扣",
    },
    {
      text: "此优惠券已永久为您激活",
      title: "平面设计 5%折扣",
    },
    {
      text: "此优惠券仅限使用一次",
      title: "印刷 2%折扣",
    },
  ],
  userLinks: {
    profile: {
      title: "概览",
      invitation: { title: "邀请好友" },
      info: { title: "个人信息" },
      edit: { title: "完善资料" },
      changePass: { title: "修改密码" },
    },
  },
  profileLinks: {
    orders: "订单",
    addresses: "地址",
  },
  customPage: {
    overview: "概览",
    personalInfo: "个人信息",
    changePassword: "修改密码",
    completeProfile: "完善资料",
    email: "邮箱",
    balance: "余额",
    phone: "手机号",
    rial: "里亚尔",
  },
  widget12: {
    inviteFriends: "邀请好友",
    viewInvitedUsers: "查看您邀请的用户列表",
    yourInviteCode: "您的邀请码",
    createNewUser: "创建新用户",
    copyText: "复制",
    userCreatedSuccess: "新用户创建成功",
    notCreated: "未创建",
  },
  userInfo: {
    userInformation: "用户信息",
    profilePicture: "头像",
    allowedFileTypes: "允许的文件类型：png、jpg、jpeg。",
    profilePictureSize: "头像必须为正方形（如：480 × 480）。",
    firstName: "姓名",
    lastName: "姓氏",
    username: "用户名",
    phone: "联系电话",
    email: "邮箱",
    receiveSMS: "接收短信",
    smsCostNote: "启用后，短信发送费用将从您的账户扣除。",
    saveChanges: "保存更改",
    profileUpdated: "您的资料已成功更新。",
  },
  emailSettings: {
    completeProfile: "完善资料",
    completeProfileDesc: "填写个人或公司信息",
    cancel: "取消",
    update: "更新",
    save: "保存",
    selectPersonType: "请选择人员类型",
    realPerson: "自然人",
    legalPerson: "法人",
    phone: "手机号",
    landline: "座机",
    fatherName: "父亲姓名",
    nationalCode: "身份证号",
    idNumber: "出生证号码",
    birthday: "出生日期",
    placeOfBirth: "出生地",
    postalCode: "邮政编码",
    email: "邮箱",
    introduction: "您是如何认识我们的",
    nationalCodePic: "身份证照片",
    plaque: "门牌号",
    address: "完整地址",
    companyName: "公司/店铺名称",
    registrationNumber: "注册号",
    economicCode: "经济代码",
    organizationIdentity: "组织国家识别号",
    companyType: "公司类型",
    activity: "经营领域",
    registrationAd: "公司注册公告图片",
    lastPublishedAd: "最近官方公告图片",
    statute: "公司章程图片",
    agentLetterPic: "代理人介绍信图片",
    successMessage: "保存成功",
    errorSelectType: "请选择一项。",
    rules: {
      companyName: "公司/店铺名称为必填项。",
      registrationNumber: "注册号为必填项。",
      economicCode: "经济代码为必填项。",
      organizationIdentity: "组织国家识别号为必填项。",
      registrationAd: "公司注册公告图片为必填项。",
      lastPublishedAd: "最近官方公告图片为必填项。",
      telephone: "座机号码为必填项。",
      fatherName: "父亲姓名为必填项。",
      nationalCode: "身份证号为必填项。",
      birthday: "出生日期为必填项。",
      idNumber: "出生证号码为必填项。",
      placeOfBirth: "出生地为必填项。",
      postalCode: "邮政编码为必填项。",
      nationalCodePic: "身份证照片为必填项。",
      address: "完整地址为必填项。",
      plaque: "门牌号为必填项。",
    },
    companyTypes: {
      governmental: "国有",
      private: "私有",
      commonStock: "上市公司",
      specialStock: "非上市公司",
    },
  },
  changePassword: {
    title: "修改密码",
    description: "更改您的账户密码",
    cancel: "取消",
    update: "更新",
    passwordInstructions: {
      forgotPassword: "如果您尚未设置密码，可点击“忘记密码”重置。",
      passwordRequirements: "密码必须至少8位，包含数字、大小写英文字母和符号。",
      passwordPrivacy: "请勿将密码告知他人。",
      keyboardLanguage: "设置密码时请确保键盘为英文输入法。",
    },
    currentPassword: "当前密码",
    newPassword: "新密码",
    confirmNewPassword: "重复新密码",
    addOrForgotPassword: "添加或忘记密码",
    changePasswordWithCode: "通过手机号修改密码",
    close: "关闭",
    change: "修改",
    enterCode: "输入验证码",
    successMessage: "密码更新成功",
    invalidCode: "验证码错误。",
    tooManyAttempts: "尝试次数过多！",
    rules: {
      required: "此项为必填。",
      min: "密码不能少于8个字符",
      equal: "两次输入的密码不一致",
      number: "请输入正确的手机号",
    },
  },
  // router 部分（路由菜单翻译）
  router: {
    dashboard: "仪表板",
    contacts: "客户俱乐部",
    editContact: "编辑客户",
    createContact: "创建客户",
    customers: "客户列表",
    contactList: "联系助手",
    messages: "消息",
    messageCategories: "消息分类",
    oldTransactions: "历史交易",
    yourTransactions: "您的交易",
    buyPanel: "购买面板",
    permissions: "权限",
    createPermission: "创建权限",
    invitations: "我的邀请列表",
    editUser: "编辑用户",
    userInformation: "查看用户信息",
    walletEdit: "编辑用户钱包信息",
    userHistory: "用户历史",
    userNotificationsHistory: "用户通知历史",
    notifications: "通知",
    createNotification: "创建通知",
    editNotification: "编辑通知",
    adminNotifications: "管理员通知",
    yourNotifications: "您的通知",
    adminNotificationsList: "管理员通知列表",
    tickets: "工单",
    createTicket: "提交新工单",
    editTicket: "编辑工单",
    departments: "部门",
    createDepartment: "新建部门",
    editDepartment: "编辑部门",
    adminTickets: "工单管理",
    discounts: "优惠",
    createDiscount: "创建优惠",
    editDiscount: "编辑优惠",
    workReports: "工作报告",
    createWorkReport: "创建工作报告",
    callMonitoring: "通话监控",
    adminWorkReports: "工作报告管理",
    editWorkReport: "查看并编辑工作报告",
    packProperties: "套餐特性",
    createPackProperty: "创建套餐特性",
    editPackProperty: "编辑套餐特性",
    panels: "面板",
    createPanel: "创建面板",
    editPanel: "编辑面板",
    transferRequests: "提现申请",
    editTransferRequest: "编辑提现申请",
    tariffs: "资费",
    createTariff: "创建资费",
    editTariff: "编辑资费",
    requests: "请求",
    viewUser: "查看用户",
    manageTransactions: "交易管理",
    viewTransaction: "查看交易",
    manageConfigs: "设置管理",
    rbLandConfigs: "机器人乐园设置管理",
    editConfig: "编辑设置",
    manageUsers: "用户管理",
    categories: "分类",
    createCategory: "添加分类",
    editCategory: "编辑分类",
    content: "内容",
    createContent: "添加内容",
    editContent: "编辑内容",
    addUserGuide: "添加用户指南",
    editUserGuide: "编辑用户指南",
    roles: "角色",
    editRole: "编辑角色",
    createRole: "添加角色",
    permissionTitle: "权限",
    paymentGateways: "支付网关",
    editPaymentGateway: "编辑支付网关",
    campaigns: "营销活动",
    createCampaign: "创建活动",
    editCampaign: "编辑活动信息",
    adminCustomers: "客户",
    createCustomer: "创建客户",
    editCustomerInfo: "编辑客户信息",
    referrerCustomers: "推荐客户",
    customerHistory: "客户历史",
    userProfile: "用户资料",
    editProfile: "编辑资料",
    inviteFriends: "邀请好友",
    personalInfo: "个人信息",
    editPersonalInfo: "编辑信息",
    changePassword: "修改密码",
    newWallet: "新钱包",
  },
  profileView: {
    email: "邮箱",
    balance: "余额",
    personType: "人员类型",
    currency: "里亚尔",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "您拥有 {title} 面板（{days}天有效期）",
    buyOrRenew: "点击下方按钮购买或续费您的面板。",
    buyPanel: "购买面板",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "资料设置",
    changePasswordTitle: "修改登录密码",
    changePasswordSubtitle: "更改您的账户登录密码。",
    alertMessage: "如果您尚未设置密码，请勾选“注册密码”选项。",
    currentPasswordLabel: "当前密码",
    setPasswordLabel: "注册密码",
    addPassword: "添加密码",
    newPasswordLabel: "新密码",
    repeatPasswordLabel: "重复密码",
    saveChanges: "保存更改",
    currentPasswordPlaceholder: "当前密码",
    newPasswordPlaceholder: "新密码",
    repeatPasswordPlaceholder: "重复密码",
  },
  profileOrders: {
    cardTitle: "订单",
    openOrders: "进行中的订单 ({count})",
    closedOrders: "已完成的订单 ({count})",
    noOrders: "您还没有下过单哦",
  },
  personalInformation: {
    cardTitle: "个人账户信息",
    cardSubtitle: "更新您的个人信息。",
    cancel: "取消",
    update: "更新",
    yourInfo: "您的信息",
    profilePicture: "头像",
    allowedFileTypes: "允许的文件类型：png、jpg、jpeg。",
    pictureSize: "头像必须为正方形（例如：480 × 480）。",
    name: "姓名",
    lastName: "姓氏",
    username: "用户名",
    receiveSMS: "接收短信",
    smsCostNote: "启用后，短信发送费用将从您的账户扣除。",
    phoneNumber: "手机号",
    phonePlaceholder: "手机号",
    email: "邮箱",
    emailPlaceholder: "邮箱",
    emailPrivacy: "我们绝不会与他人分享您的邮箱。",
    successMessage: "您的资料已成功更新。",
  },
  userInfoForm: {
    companyName: "公司/店铺名称",
    registrationNumber: "注册号",
    economicCode: "经济代码",
    organizationIdentity: "组织国家识别号",
    companyType: "公司类型",
    activity: "经营领域",
    registrationAd: "公司注册公告图片",
    lastPublishedAd: "最近官方公告图片",
    statute: "公司章程图片",
    argentLetterPic: "代理人介绍信图片",
    phone: "手机号",
    telephone: "座机号码",
    fatherName: "父亲姓名",
    nationalCode: "身份证号",
    id: "出生证号码",
    birthday: "出生日期",
    placeBirthday: "出生地",
    postalCode: "邮政编码",
    email: "邮箱",
    introduction: "您是如何认识我们的",
    nationalCodePic: "身份证照片",
    plaque: "门牌号",
    address: "完整地址",
    companyTypes: {
      governmental: "国有",
      private: "私有",
      common_stock: "上市公司",
      special_stock: "非上市公司",
    },
    rules: {
      companyName: "公司/店铺名称为必填项。",
      registration_number: "注册号为必填项。",
      economic_code: "经济代码为必填项。",
      organization_identity: "组织国家识别号为必填项。",
      registration_ad: "公司注册公告图片为必填项。",
      last_published_ad: "最近官方公告图片为必填项。",
      telephone: "座机号码为必填项。",
      fatherName: "父亲姓名为必填项。",
      nationalCode: "身份证号为必填项。",
      id: "出生证号码为必填项。",
      birthday: "出生日期为必填项。",
      placeBirthday: "出生地为必填项。",
      postalCode: "邮政编码为必填项。",
      nationalCodePic: "身份证照片为必填项。",
      address: "完整地址为必填项。",
      plaque: "门牌号为必填项。",
    },
  },
  createUserForm: {
    name: "姓名",
    lastName: "姓氏",
    nid: "身份证号",
    phone: "手机号",
    create: "创建",
    errors: {
      nameRequired: "请填写姓名！",
      lastNameRequired: "请填写姓氏！",
      nidRequired: "请填写身份证号！",
      phoneRequired: "请填写手机号！",
    },
  },
  lastView: {
    cardTitle: "您的最近访问",
    cardSubtitle: "您最近访问的页面",
    tableHeaders: {
      page: "页面",
      address: "地址",
      enterDate: "进入时间",
      leaveDate: "离开时间",
      timeSpent: "在本页停留时间",
    },
    viewAll: "查看全部",
    timeUnit: "分钟",
    pages: {
      home: "首页",
      panels: "面板",
      profile: "完善资料",
    },
  },
walletWidget: {
  title: "最近交易",
  balanceLabel: "您的余额：",
  viewTransactions: "查看交易",
  transactionTypes: {
    withdraw: "提现",
    deposit: "入金",
    charge: "钱包充值",
    refund: "退款",
    default: "交易",
    adminCharge: "管理员调整",
    agency: "代理佣金",
  },
},
  panelWidget: {
    title: "您拥有 {title} 面板（{days}天有效期）",
    renewPrompt: "点击下方按钮购买或续费您的面板",
    buyPanel: "购买面板",
    percentage: "{value}%",
    infinity: "∞",
    days: "{count} 天",
  },
  component: {
    title: "您邀请的用户",
    columns: {
      row: "序号",
      name: "姓名",
      family: "姓氏",
      username: "用户名",
      phone: "手机号",
      created_at: "注册时间",
      actions: "操作",
    },
    unknown: "未知",
    error: "错误",
    breadcrumb: "邀请的用户",
  },
  table: {
    itemsPerPage: "每页行数",
    pageText: "显示 {0} - {1} 共 {2} 条",
    prevText: "上一页",
    nextText: "下一页",
    noDataText: "暂无数据",
    search: "搜索",
  },
  UserHistory: {
    title: "用户历史记录",
    add_history: "登记新历史",
    send_message: "发送消息",
    close: "关闭",
    save: "保存",
    cancel: "取消",
    new_history_dialog_title: "登记新历史",
    send_message_dialog_title: "发送消息",
    negotiations: "已进行的谈判",
    follow_up: "下次联系跟进事项",
    success_history: "历史记录登记成功。",
    success_message: "消息发送成功。",
    columns: {
      id: "ID",
      title: "标题",
      status: "阶段",
      current_time_date: "最近联系日期",
      current_time_hour: "最近联系时间",
      next_time_date: "下次联系日期",
      next_time_hour: "下次联系时间",
      user_id: "支持人员",
      actions: "操作",
    },
    table: {
      itemsPerPage: "每页行数",
      pageText: "显示 {0} - {1} 共 {2} 条",
      prevText: "上一页",
      nextText: "下一页",
      noDataText: "暂无数据",
      search: "搜索",
    },
    form: {
      title: "标题",
      status: "阶段",
      current_time: "最近联系日期",
      description: "说明",
      next_time: "下次联系日期",
      pursue_text: "下次跟进内容",
      category: "选择分类",
      message_title: "消息标题",
    },
  },
  newUserTransactions: {
    userWallet: "用户钱包",
    transactionList: "交易列表",
    userTransactions: "用户交易",
    terminal: "终端",
    liveSms: "实时短信",
    realEstateNews: "Divar最新动态",
    rial: "里亚尔",
    row: "序号",
    uniqueId: "唯一ID",
    amount: "金额",
    time: "时间",
    createdAt: "日期",
    description: "补充说明",
    type: "交易类型",
    product_description: "说明",
    serviceId: "服务名称",
    balanceAfter: "交易后余额",
    perPage: "每页数量",
    search: "搜索",
    balance: "余额",
    transactionListTooltip: "交易列表",
    panelLogin: "登录面板",
    history: "历史",
    error: {
      terminalWallet: "获取终端钱包失败",
    },
    transactionType: "交易类型",
    service: "服务",
    dateFrom: "起始日期",
    dateTo: "结束日期",
    oldWallet: "旧钱包",
    depositReceipt: "充值收据",
    showReceipt: "查看收据",
    transactionTypes: {
      online: "在线支付",
      admin: "管理员操作",
      refund: "修正交易",
      agency: "代理",
      withdraw: "提现",
      deposit: "转入",
      adminCharge: "管理员充值",
      charge: "钱包充值",
      refund: "退款",
    },
    error: {
      imageLoad: "图片加载失败！",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "请仔细选择面板类型！",
    },
    dialog: {
      title: "购买面板",
      confirmPurchase: "您确定要购买 {title} 面板吗？",
      discountCodeLabel: "优惠码",
      discountCodePlaceholder: "请输入您的优惠码",
      applyDiscount: "应用优惠码",
      purchase: "购买",
      iHaveDiscount: "我有优惠码",
    },
    toast: {
      discountApplied: "优惠码应用成功！",
      purchaseSuccess: "套餐购买成功",
      error: "发生错误：{message}",
      unauthorized: "请先登录",
      validationError: "验证错误：{message}",
    },
    currency: "里亚尔",
  },
  panelCard: {
    rial: "里亚尔",
    days: "天",
    buyPanel: "购买面板",
  },
  cons: {
    title: "选择表情符号",
  },
  cons1: {
    title: "默认文本",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "大型广告终端系统",
  },
};
